<script>
import Notification from "../reUse/Notification.vue"
import { i18n } from '@/i18n'
import sl from '@/Prevodi/PotrdiNalog-sl.json';
import en from '@/Prevodi/PotrdiNalog-en.json';
import it from '@/Prevodi/PotrdiNalog-it.json';
import {config} from "@/config";
export default {
  components: {
    Notification,
  },
  emits: ['odjava'],

  data() {
    return {
      prevodi: false,
      showSkupno: false,
      isLoading: false,
      ShowPotrjevanje: false,
      FoDokumenti: [],
      FoPotrjeni: [],
      FoZavrnjeni: [],
      SkupnoDok: 0,
      Zavrnjeni: 0,
      Potrjeni: 0,
      NePotrjeni: 0,
      NaCakanju: [],
      IzbranDokument: [],
      dokument: '',
      opomba: '',
      showZavrnjeni: false,
      showOdobreni: false,
      vrsta: '',
      potrjujem: false,
      //notification
      ShowNoti: false,
      text: '',
      types: '',
      izbira: '',
      user: config.FullUser.id,
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.BranjeFoNePotrjeni();
    this.BranjeFo();
    this.PreveriSestevek();
  },
  methods: {
    testiram() {
      this.dokument = this.IzbranDokument[0].dokument;
      if (this.IzbranDokument[0].potrjeno === 0) {
        this.vrsta = 'nedodeljeni';
      } else {
        this.vrsta = '';
      }
      // console.log(this.dokument);
    },
    OpenSkupno() {
      this.showSkupno = !this.showSkupno;
    },
    OpenPotrjevanje() {
      this.ShowPotrjevanje = !this.ShowPotrjevanje;
    },
    OpenOdobreni() {
      this.showOdobreni = !this.showOdobreni;
    },
    OpenZavrnjeni() {
      this.showZavrnjeni = !this.showZavrnjeni;
    },
    BranjeFoNePotrjeni() {
      axios
          .get("./api/flightorder/preberi/nepotrjeni/", {withCredentials: true})
          .then((response) => {
            this.NaCakanju = response.data.podatki;
            this.NePotrjeni = response.data.podatki.length;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri branju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
            this.isLoading = false;
          })
    },
    BranjeFo() {
      axios
          .get("./api/flightorder/preberi/", {withCredentials: true})
          .then((response) => {
            this.FoDokumenti = response.data.podatki;
            this.SortiranjeDokumentov();
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
            } else {
              this.text = 'Napaka pri branju podatkov.';
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
            this.isLoading = false;
          })
    },
    SortiranjeDokumentov() {
      this.FoZavrnjeni = new Array;
      this.FoPotrjeni = new Array;
      for (var i = 0; i < this.FoDokumenti.length; i++) {
        if (Number(this.FoDokumenti[i].potrjeno) === -1) {
          this.Zavrnjeni++;
          this.FoZavrnjeni.push(this.FoDokumenti[i]);
        } else if (Number(this.FoDokumenti[i].potrjeno) === 1) {
          this.Potrjeni++;
          this.FoPotrjeni.push(this.FoDokumenti[i]);
        }
        // else {
        //     this.NePotrjeni++;
        //     this.NaCakanju.push(this.FoDokumenti[i]);
        // }
      }
    },
    Details(id) {
      this.IzbranDokument = this.NaCakanju.filter(zapis => zapis.id === id);
      this.testiram();
      $(this.$refs.modalKartice).modal('show');
    },
    DetailsNoEditZavrnjeni(id) {
      this.IzbranDokument = this.FoZavrnjeni.filter(zapis => zapis.id === id);
      this.testiram();
      $(this.$refs.modalKartice).modal('show');
    },
    DetailsNoEditOdobreni(id) {
      this.IzbranDokument = this.FoPotrjeni.filter(zapis => zapis.id === id);
      this.testiram();
      $(this.$refs.modalKartice).modal('show');
    },
    DetailsOff() {
      $(this.$refs.modalKartice).modal('hide');
      this.urejanje = false;
      // ponastavitev podatkov
      // this.idUrejanja = '';
      // this.odhod_cas = '';
      // this.krajVzleta = '';
      // this.krajPristanka = '';
      // this.varianta = '';
      // this.regLetala = '';
      // this.imeVodje = '';
      // this.pogoji = '';
      // this.pristanki = 0;
      // this.posadka = '';
      // this.ttof = '';
      // this.vloga = '';
      // this.operativa = '';
      // this.fstd = '';
      // this.prihod_cas = '';
      this.opombe = '';
    },
    OdstraniPotnika(index) {
      this.text = 'Ali res želiš izbrisati potnika?';
      this.types = 'Vprašanje';
      this.ShowNoti = true;
      this.indexBrisanja = index;
    },
    ZavrniDokument() {
      this.potrjujem = true;
      this.text = 'Ali res želite ZAVRNITI dokument?';
      this.types = 'Vprašanje';
      this.izbira = 'zavrni';
      this.ShowNoti = true;
    },
    OdobriDokument() {
      this.potrjujem = true;
      this.text = 'Ali res želite POTRDITI dokument?';
      this.types = 'Vprašanje';
      this.izbira = 'potrdi'
      this.ShowNoti = true;
    },
    OdgovoriDa() {
      let podatki;
      if (this.izbira === 'zavrni') {
        podatki = new URLSearchParams();
        podatki.append('id_dokumenta', this.IzbranDokument[0].id);
        if (this.opomba === '') {
          this.potrjujem = false;
          this.text = 'Dodaj "opombo" zakaj zavračaš nalog!';
          this.types = "Napaka";
          this.ShowNoti = true;
          return
        }
        podatki.append('opomba', this.opomba);
        podatki.append('poslal_id', this.IzbranDokument[0].poslal_id);
        if (this.IzbranDokument[0].letalo_id !== null) {
          podatki.append('letalo_id', this.IzbranDokument[0].letalo_id);
        }
        axios.post('./api/flightorder/zavrni/', podatki, {withCredentials: true})
            .then((response) => {
              this.potrjujem = false;
              this.text = response.data.sporocilo;
              this.types = "Uspešno";
              this.ShowNoti = true;
              this.DetailsOff();
              this.BranjeFoNePotrjeni();
              this.BranjeFo();
            }).catch((napaka) => {
              this.potrjujem = false;
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = 'Napaka pri zavračanju naloga. ' + napaka.response.data.napaka;
          } else {
            this.text = 'Napaka pri zavračanju naloga.';
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
          this.isLoading = false;
        });
      }
      if (this.izbira === 'potrdi') {
        podatki = new URLSearchParams();
        podatki.append('id_dokumenta', this.IzbranDokument[0].id);
        podatki.append('poslal_id', this.IzbranDokument[0].poslal_id);
        podatki.append('opomba', this.opomba);
        if (this.IzbranDokument[0].letalo_id !== null) {
          podatki.append('letalo_id', this.IzbranDokument[0].letalo_id);
        }
        axios.post('./api/flightorder/potrdi/', podatki, {withCredentials: true})
            .then((response) => {
              this.opomba = '';
              this.potrjujem = false;
              this.text = response.data.sporocilo;
              this.types = "Uspešno";
              this.ShowNoti = true;
              this.DetailsOff();
              this.BranjeFo();
              this.BranjeFoNePotrjeni();
            }).catch((napaka) => {
              this.potrjujem = false;
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = 'Napaka pri potrjevanju naloga. ' + napaka.response.data.napaka;
          } else {
            this.text = 'Napaka pri potrjevanju naloga.';
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
          this.isLoading = false;
        });
      }
      this.ShowNoti = false;
    },
    PreveriSestevek() {
      this.SkupnoDok = this.FoDokumenti.length + this.NaCakanju.length;
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
  }
}
</script>
<template>
  <div class="pregled-povrsin-container" v-if="prevodi">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>{{$t('main.nazaj')}}</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">{{$t('main.title')}}</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>
      </div>
    </div>
  </div>
  <div class="col-12" v-if="prevodi">
    <div class="container">
      <div class="drop-down-icon text-black" @click.prevent="OpenSkupno(), PreveriSestevek()">
        <i v-show="!showSkupno" class="fas fa-chevron-right"></i>
        <i v-show="showSkupno" class="fas fa-chevron-down"></i>
      </div>
      <button class="btn-prikaz-povzetka border-0 rounded-4 p-2 fs-5"  id="Skupno" @click.prevent="OpenSkupno(), PreveriSestevek()">{{$t('buttons.stevilcni')}}</button>
      <transition name="fade">
        <div v-if="showSkupno" class="container row p-2">
          <div class="col-12 col-md-6 p-1">
            <div class="container">
              <div class="container shadow-lg border-1 rounded-3 skupni-podatki">
                <div class='text-white p-2'>
                  <p class="fs-6 text-podatki">{{$t('stevilcni.vsiD')}}</p>
                  <p class="fs-6 fw-bold">{{ SkupnoDok }}</p>
                </div>
              </div>
              <div class="p-1"></div>
              <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
                <div class='text-white p-2'>
                  <p class="fs-6 text-podatki">{{$t('stevilcni.vsiN1')}} <strong class="text-danger">{{$t('stevilcni.vsiN2')}}</strong>{{$t('stevilcni.vsiN3')}}</p>
                  <p class="fs-6 fw-bold">{{ NePotrjeni }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 p-1">
            <div class="container">
              <!-- <div class="p-1"></div> -->
              <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
                <div class='text-white p-2'>
                  <p class="fs-6 text-podatki">{{$t('stevilcni.vsiP')}}</p>
                  <p class="fs-6 fw-bold">{{ Potrjeni }}</p>
                </div>
              </div>
              <div class="p-1"></div>
              <div class="container shadow-sm border-1 rounded-3 skupni-podatki">
                <div class='text-white p-2'>
                  <p class="fs-6 text-podatki">{{$t('stevilcni.vsiZ')}}</p>
                  <p class="fs-6 fw-bold">{{ Zavrnjeni }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- Odobri / Zavrni  -->
    <div class="container">
      <div class="drop-down-icon text-black" @click.prevent="OpenPotrjevanje()">
        <i v-show="!ShowPotrjevanje" class="fas fa-chevron-right"></i>
        <i v-show="ShowPotrjevanje" class="fas fa-chevron-down"></i>
      </div>
      <button class="btn-prikaz-povzetka border-0 rounded-4 p-2 fs-5" id="Skupno" @click.prevent="OpenPotrjevanje()">
        <strong class="text-success">{{$t('potrjevanje.odobri')}}</strong> / <strong class="text-danger">{{$t('potrjevanje.zavrni')}}</strong> {{$t('potrjevanje.naloge')}}</button>
      <transition name="fade">
        <!-- IZPIS -->
        <section class="nalogi-section-pregled mt-2" v-if="ShowPotrjevanje">

          <div class="section-header">
            <div class="section-icon motor">
              <i class="fas fa-book"></i>
            </div>
            <div class="d-flex col-10 justify-content-between">
              <div>
                <h2>{{ $t('table.nalogiTitle') }}</h2>
                <span>{{ NaCakanju.length }} zapisov</span>
              </div>
            </div>
          </div>

          <div class="flight-list">

            <div
                class="nalog-item-pregled"
                v-for="id in NaCakanju" :key="id.id"
                @click.prevent="Details(id.id)"
            >
              <div class="flight-date">
                <i class="fas fa-calendar"></i>
                <strong>{{ id.datum }}</strong>
              </div>

              <div class="flight-task">
                <span class="label-flight">{{ $t('potrjevanje.poslal') }}</span>
                <strong>{{ id.poslal }}</strong>
              </div>

              <div class="flight-action">
                <i class="fas fa-chevron-right"></i>
              </div>
            </div>

            <div v-if="!NaCakanju.length" class="empty-state">
              <i class="far fa-folder-open"></i>
              <span>Ni podatkov</span>
            </div>

          </div>

        </section>
        <!-- /IZPIS -->
      </transition>
    </div>
    <!-- VSI ODOBRENI-->
    <div class="container">
      <div class="drop-down-icon text-black" @click.prevent="OpenOdobreni()">
        <i v-show="!showOdobreni" class="fas fa-chevron-right"></i>
        <i v-show="showOdobreni" class="fas fa-chevron-down"></i>
      </div>
      <button class="btn-prikaz-povzetka border-0 rounded-4 p-2 fs-5" id="Skupno" @click.prevent="OpenOdobreni()">
        Vsi <strong class="text-success">{{$t('potrjevanje.odobreni')}}</strong> {{$t('potrjevanje.nalogi')}}</button>
      <transition name="fade">
        <!-- IZPIS -->
        <section class="nalogi-section-pregled mt-2" v-if="showOdobreni">

          <div class="section-header">
            <div class="section-icon motor">
              <i class="fas fa-book"></i>
            </div>
            <div class="d-flex col-10 justify-content-between">
              <div>
                <h2>{{ $t('table.nalogiTitle') }}</h2>
                <span>{{ FoPotrjeni.length }} zapisov</span>
              </div>
              <div>
                <strong class="text-success">{{$t('potrjevanje.odobreni').toUpperCase()}}</strong>
              </div>
            </div>
          </div>

          <div class="flight-list">

            <div
                class="nalog-item-pregled"
                v-for="id in FoPotrjeni" :key="id.id"
                @click.prevent="DetailsNoEditOdobreni(id.id)"
            >
              <div class="flight-date">
                <i class="fas fa-calendar"></i>
                <strong>{{ id.datum }}</strong>
              </div>

              <div class="flight-task">
                <span class="label-flight">{{ $t('potrjevanje.poslal') }}</span>
                <strong>{{ id.poslal }}</strong>
              </div>

              <div class="flight-action">
                <i class="fas fa-chevron-right"></i>
              </div>
            </div>

            <div v-if="!FoPotrjeni.length" class="empty-state">
              <i class="far fa-folder-open"></i>
              <span>Ni podatkov</span>
            </div>

          </div>

        </section>
        <!-- /IZPIS -->
      </transition>
    </div>
    <!-- VSI ZAVRNJENI-->
    <div class="container">
      <div class="drop-down-icon text-black" @click.prevent="OpenZavrnjeni()">
        <i v-show="!showZavrnjeni" class="fas fa-chevron-right"></i>
        <i v-show="showZavrnjeni" class="fas fa-chevron-down"></i>
      </div>
      <button class="btn-prikaz-povzetka border-0 rounded-4 p-2 fs-5" id="Skupno" @click.prevent="OpenZavrnjeni()">
        Vsi <strong class="text-danger">{{$t('potrjevanje.zavrnjeni')}}</strong> {{$t('potrjevanje.nalogi')}}</button>
      <transition name="fade">
        <!-- IZPIS -->
        <section class="nalogi-section-pregled mt-2" v-if="showZavrnjeni">

          <div class="section-header">
            <div class="section-icon motor">
              <i class="fas fa-book"></i>
            </div>
            <div class="d-flex col-10 justify-content-between">
              <div>
                <h2>{{ $t('table.nalogiTitle') }}</h2>
                <span>{{ FoZavrnjeni.length }} zapisov</span>
              </div>
              <div>
                <strong class="text-danger">{{$t('potrjevanje.zavrnjeni').toUpperCase()}}</strong>
              </div>
            </div>
          </div>

          <div class="flight-list">

            <div
                class="nalog-item-pregled"
                v-for="id in FoZavrnjeni" :key="id.id"
                @click.prevent="DetailsNoEditZavrnjeni(id.id)"
            >
              <div class="flight-date">
                <i class="fas fa-calendar"></i>
                <strong>{{ id.datum }}</strong>
              </div>

              <div class="flight-task">
                <span class="label-flight">{{ $t('potrjevanje.poslal') }}</span>
                <strong>{{ id.poslal }}</strong>
              </div>

              <div class="flight-action">
                <i class="fas fa-chevron-right"></i>
              </div>
            </div>

            <div v-if="!FoZavrnjeni.length" class="empty-state">
              <i class="far fa-folder-open"></i>
              <span>Ni podatkov</span>
            </div>

          </div>

        </section>
        <!-- /IZPIS -->
      </transition>
    </div>
  </div>
  <!-- PILOT PODROBNO -->
  <div class="modal modal-kartica" ref="modalKartice" tabindex="-1" role="dialog" v-if="prevodi">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content list-dark border-orange" v-if="IzbranDokument.length > 0">
        <div class='d-flex justify-content-end'>
          <button class="modern-close-btn mt-2 me-2" @click.prevent="DetailsOff">
            <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
          </button>
        </div>
        <div class='modal-header'>
          <h5 class="card-title"><i class="far fa-id-card fa-lg"></i> {{IzbranDokument[0].datum}} - {{IzbranDokument[0].poslal}}</h5>
        </div>
        <div class="modal-body col-12">
          <iframe :src="'./letalstvo_v2/'+dokument" width="100%" height="600"></iframe>
          <br>
          <div class="container border-danger" v-if="this.vrsta === 'nedodeljeni'">
            <label :class="{ hidden: opomba.length > 0 }" class="label" for="opomba">{{$t('modal.opomba')}}</label>
            <textarea class="input-comment border-0 rounded-4 p-2 fs-5" type="textarea" id="opomba" v-model="opomba" rows="6" autocomplete="off">
                    </textarea>
          </div>
        </div>
        <div class="modal-footer col-12">
          <div class="modal-footer col-12">
            <button v-if="this.vrsta === 'nedodeljeni'" :disabled="potrjujem" class="btn btn-outline-danger" @click.prevent="ZavrniDokument()"><i class="fas fa-ban" :class="{'fa-spin': potrjujem}"></i> {{$t('buttons.zavrniDokument')}}</button>
            <button v-if="this.vrsta === 'nedodeljeni'" :disabled="potrjujem" class="btn btn-outline-success" @click.prevent="OdobriDokument()"><i class="fas fa-clipboard-check" :class="{'fa-spin': potrjujem}"></i> {{$t('buttons.potrdiDokument')}}</button>&nbsp;
            <button v-if="this.vrsta !== 'nedodeljeni'" class="btn btn-outline-secondary" @click.prevent="DetailsOff">{{$t('buttons.zapriPregled')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ODMIK OD ROBA -->
  <div class="w-100 p-4"></div>
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @da="OdgovoriDa()" @ne="ShowNoti = false; potrjujem = false" @closeNotification="ShowNoti = false" />
  </Transition>
</template>
<style>
.nalogi-section-pregled {
  background: #151922;

  border: 1px solid #292f3b;
  border-radius: 14px;

  overflow-y: scroll;
  max-height: 50vh;
  box-shadow: 0 8px 30px rgba(0, 0, 0, .12);
}
.nalog-item-pregled {
  display: grid;

  grid-template-columns: 1fr 1fr auto;

  align-items: center;

  gap: 20px;

  padding: 13px 15px;

  border-radius: 9px;

  cursor: pointer;

  transition:
      background .2s ease,
      transform .2s ease;
  border: 1px solid gray;
  margin-top: 0.5rem;
}
.nalog-item-pregled:hover {
  background: #1e2530;
}
@media (max-width: 900px) {

  .nalog-item-pregled {
    grid-template-columns: 1fr 1fr;
    gap: 2px;
    position: relative;
    padding-right: 55px;
    border-bottom: 1px solid gray;
  }
}


@media (max-width: 650px) {

  .nalog-item-pregled {
    grid-template-columns: 1fr;
  }
}
</style>